import { Link } from "react-router-dom";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/faqs";

export default function FaqPreview() {
  const preview = faqs.slice(0, 5);

  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-background-100 border-y border-background-200" aria-labelledby="faq-preview-title">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10">
        <div className="lg:col-span-4">
          <p className="inline-flex items-center gap-2 text-xs font-label tracking-widest text-primary-600 uppercase">
            <span className="w-5 h-px bg-primary-400"></span>
            常见问题
          </p>
          <h2 id="faq-preview-title" className="mt-3 font-heading text-2xl md:text-[32px] font-bold text-foreground-950 leading-snug">
            投稿前，你可能想问
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            关于匿名、关于审核、关于材料去向，我们把最常被问到的几个问题整理在了这里。
          </p>
          <Link
            to="/faq"
            className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-foreground-300 text-foreground-900 text-sm font-label font-medium whitespace-nowrap hover:bg-foreground-950 hover:text-background-50 transition-colors cursor-pointer"
          >
            查看全部问题
            <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
          </Link>
        </div>

        <div className="lg:col-span-8">
          <FaqAccordion items={preview} defaultOpen={0} />
        </div>
      </div>
    </section>
  );
}